import { z } from "zod";

const airtableErrorTypeValues = ["LIST_RECORDS_FAILED"] as const;

const airtableErrorTypeSchema = z.enum(airtableErrorTypeValues);
const AirtableErrorType = airtableErrorTypeSchema.enum;
type AirtableErrorType = z.infer<typeof airtableErrorTypeSchema>;

interface ErrorDetails {
  sentryDescription: string;
}

export type AirtableErrors = {
  errorType: typeof AirtableErrorType.LIST_RECORDS_FAILED;
  data: {
    baseId: string;
    tableId: string;
    status: number;
    body: string;
  };
};

export const airtableErrorDetails: Record<AirtableErrorType, ErrorDetails> = {
  [AirtableErrorType.LIST_RECORDS_FAILED]: {
    sentryDescription: "Airtable list records request failed",
  },
};
